export function makeBackground(color) {
    return 'linear-gradient(var(--background1), var(--background))';
}
export function makeCoverBackground(color) {
    return `var(--background1)`;
}
